import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
  })
export class Dashboardres {

    status:any;
    msg:any;
}
